"use client";

import React from "react";
import { Quote } from "lucide-react";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { ScrollArea } from "@/components/ui/scroll-area";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const testimonials = [{
  id: 1,
  name: "甘小姐",
  role: "長者家庭照顧者",
  location: "長沙灣",
  quote: "憬芯醫療的團隊非常專業，讓我在家中也能得到全面的照護，非常放心。",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606170/img/avatar_female_1.png",
  initials: "甘"
}, {
  id: 2,
  name: "劉小姐",
  role: "康復患者家屬",
  location: "九龍灣",
  quote: "服務貼心又細心，復康效果明顯，感謝他們的耐心與專業，讓家人重拾笑容。",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606170/img/avatar_female_2.png",
  initials: "劉"
}, {
  id: 3,
  name: "黃先生",
  role: "服務使用者",
  location: "沙田",
  quote: "醫療團隊非常有愛心，讓我在療癒的同時感受到溫暖與關懷，服務質素極高。",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606170/img/avatar_male_1.png",
  initials: "黃"
}, {
  id: 4,
  name: "陳太太",
  role: "中風康復者家屬",
  location: "荃灣",
  quote: "物理治療師非常細心，為我先生度身訂造復康計劃，現在他已經可以自己慢慢行走了。",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606170/img/avatar_female_3.png",
  initials: "陳"
}];
export default function WarmHeartServiceEvaluation() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="73535" id="服務使用者見證" className="dark relative w-full py-20 md:py-32 bg-background text-foreground overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-primary/20 blur-[120px]" />
        <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-secondary/10 blur-[120px]" />
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          
          <div ref={headerRef} className={cn("lg:col-span-5 flex flex-col gap-6 transition-all duration-1000 ease-out", isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
            <div className="inline-flex items-center gap-2">
              <span className="h-px w-8 bg-primary"></span>
              <span className="text-primary font-medium tracking-wider text-sm uppercase">誠「芯」見證</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-foreground leading-tight tracking-tight" style={{
            fontFamily: 'var(--font-heading)'
          }}>
              服務使用者<br className="hidden md:block" />
              <span className="text-primary">真摯見證</span>
            </h2>
            <p className="text-lg text-muted-foreground leading-relaxed max-w-md">
              我們深信「憬於未來，芯繫健康」。每一位服務使用者的康復與笑容，都是對我們專業居家護理團隊最大的肯定與動力。
            </p>
          </div>

          <div className="lg:col-span-7 relative">
            <div className="absolute top-0 left-0 w-full h-12 bg-gradient-to-b from-background to-transparent z-10 pointer-events-none" />
            <div className="absolute bottom-0 left-0 w-full h-12 bg-gradient-to-t from-background to-transparent z-10 pointer-events-none" />

            <ScrollArea className="h-[500px] md:h-[600px] w-full pr-4 md:pr-6">
              <div className="flex flex-col gap-6 py-8">
                {testimonials.map((item, i) => <div key={item.id} data-index={i} className={cn("w-full transition-all duration-500 hover:-translate-y-1", i % 2 !== 0 ? "md:ml-12" : "md:mr-12")}>
                    <Card className="bg-card/80 backdrop-blur-md border-border/50 shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden relative group rounded-3xl">
                      <div className="absolute top-6 right-6 text-primary/10 group-hover:text-primary/20 transition-colors duration-300">
                        <Quote size={64} strokeWidth={1} />
                      </div>
                      
                      <CardHeader className="pb-2 flex flex-row items-center gap-4 relative z-10">
                        
                        
                        <div className="flex flex-col gap-1">
                          <div className="flex items-center gap-2 flex-wrap">
                            <h4 className="font-semibold text-foreground text-lg leading-none">
                              {item.name}
                            </h4>
                            <Badge variant="secondary" className="bg-secondary/50 text-secondary-foreground hover:bg-secondary/70 transition-colors rounded-full">
                              {item.location}
                            </Badge>
                          </div>
                          <span className="text-sm text-muted-foreground">
                            {item.role}
                          </span>
                        </div>
                      </CardHeader>
                      
                      <CardContent className="relative z-10 pt-2">
                        <p className="text-foreground/90 text-2xl leading-relaxed italic" style={{
                      fontFamily: 'var(--font-hero)'
                    }}>
                          "{item.quote}"
                        </p>
                      </CardContent>
                    </Card>
                  </div>)}
              </div>
            </ScrollArea>
          </div>

        </div>
      </div>
    </section>;
}